import React from 'react';
import { Link } from '../types';
import { StyledLinkAttribute as LinkAttribute } from './styles';

export const AttributesLink: React.VFC<Link> = ({
  id,
  label,
  url,
  openInNewTab,
  disabled,
  toolTip,
  tooltipPosition,
  ariaLabel,
}) => (
  <>
    <LinkAttribute
      id={id}
      disabled={disabled}
      helptipText={toolTip}
      helptipTextPosition={tooltipPosition}
      href={url}
      external={openInNewTab}
      aria-label={ariaLabel}
      data-ccx-e2e-id={`aac-attribute-${id}`}
    >
      {label}
    </LinkAttribute>
  </>
);
